//
// SpecificConfig.js
//
import ProvidersConfig from './providers/ProvidersConfig'
import ProviderConfig from './provider/ProviderConfig'

const SpecificConfigs = [ProviderConfig, ProvidersConfig]

export default SpecificConfigs
